import GradientLayer from "../../components/editor/layers/city/GradientLayer";
import MapLayer from "../../components/editor/layers/city/MapLayer";

export const cityCircleStyles = [
    {
        'name': 'Standaard',
        'slug': 'gradient',
        'preview': '/img/editor/coordinates/bigcoordinates.png',
        'layers': [
            MapLayer,
            GradientLayer,
        ],
    },
    {
        'name': 'Minimal',
        'slug': 'minimal',
        'preview': '/img/editor/coordinates/bigcoordinates.png',
        'layers': [
            MapLayer,
        ],
    },
];